<template>
  <div>
    <header v-if="!notShowHead" id="page-head">
      <div class="nav-head">
        <div class="d-flex mb-100-screen-768 align-items-center">
          <div class="input-search input-search-head">
            <div class="topHeadSearch">
              <i class="head-icon-search fa fa-search"></i>
              <input class="inputSearchHead" placeholder="Nhập tên Sản phẩm, mã SKU,..." v-model="textSearchHead" @keyup="onKeyUpSearchItem" @click="showDataSearchHead = true" />
              <i class="head-icon-remove bx bx-x" v-if="textSearchHead != ''" @click="textSearchHead = ''"></i>
            </div>
            <div class="openPopOverHeadSearch" v-if="showDataSearchHead" @click="showDataSearchHead = false"></div>
            <div class="bottomHeadSearch" v-if="showDataSearchHead">
              <div class="addItemFastHead" @click="clickShowPopAddItem">
                <div class="clickItemFastHead">
                  <span class="iconAdd"><i class="el-icon-plus"></i></span>
                  <b>Thêm mới sản phẩm</b>
                </div>
              </div>
              <div class="boxShowHeadSearchItem" v-if="listVariationsNew.length > 0">
                <div
                  class="item-variations-content-head"
                  v-for="(item, index) in listVariationsNew"
                  :key="index"
                  @click="chooseVariationItem(item, item.idItem, item.useImeiAndSerial, item.useProductBatch)"
                >
                  <div class="v-image">
                    <img :src="item.images[0] || defaultImg" />
                  </div>
                  <div class="v-content d-flex">
                    <div class="v-info">
                      <div class="v-name">{{ item.name }}</div>
                      <div class="v-sku">{{ item.upc }}</div>
                    </div>
                    <div class="v-value">
                      <div class="v-price">{{ formatMoney(item.price) }}</div>
                      <div v-if="datas.enableInventory">
                        <div class="v-quantity" v-if="item.stockQuantity > 0">SL: {{ item.stockQuantity }} {{ item.unit ? item.unit : "" }}</div>
                        <div class="v-quantity text-danger-on" v-else>Hết hàng</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ul class="pos-item">
            <li v-for="(item, index) in datas.orders" :key="index" :class="item.rm_id === getRmId ? 'act' : ''">
              <span class="pos-item-name" @click="transferPos(item.rm_id)"> Đơn {{ index + 1 }} </span>
              <span class="pull-right font-size-12 pointer pos-item-delete" :class="item.rm_id === getRmId ? 'text-default-on' : 'text-info-on'" @click="deletePos(item.rm_id)"
                ><i class="fa fa-remove"></i
              ></span>
            </li>
            <li class="icon-plus-click" @click="addNewPos"><i class="fa fa-plus"></i></li>
          </ul>
        </div>
        <div class="d-flex mb-100-screen-678 align-items-center">
          <div class="input-users">
            <span class="i-home" @click="dashboard">
              <img src="@/assets/images/ic-home.svg" alt="" />
            </span>
            <span class="i-zoom" @click="fullScreen">
              <img src="@/assets/images/i-zoom.svg" alt="" />
            </span>
            <span class="branch-name" @click="selectLocation">
              <span class="i-store">
                <img src="@/assets/images/i-store.svg" alt="" />
              </span>

              <span class="name-show">{{ locationNameSelected }}</span>
              <i class="icon-drop-down bx bx-chevron-down fz-20"></i>
            </span>
            <div class="box-users">
              <b-dropdown right variant="black" toggle-class="header-item-info">
                <template v-slot:button-content>
                  <div class="head-users">
                    <img class="rounded-circle header-profile-user" :src="defaultImg" />
                    <i class="icon-drop-down bx bx-chevron-down fz-20"></i>
                  </div>
                </template>
                <b class="dropdown-item text-danger cursor" @click="logout()">
                  <i class="bx bx-power-off font-size-18 align-middle mr-1 text-danger"></i>
                  Đăng xuất
                </b>
              </b-dropdown>
            </div>
          </div>
        </div>
      </div>

      <LayoutPopup id="chon-chi-nhanh" class="branch-choose">
        <template #title>Chọn chi nhánh</template>
        <template #content>
          <div class="content-block" v-for="location in listLocation" :key="location.coLocationId" @click="setLocation(location)">
            <span>{{ location.name }}</span>
            <span class="pull-right text-primary"><i class="fa fa-arrow-right"></i></span>
          </div>
        </template>
        <template #control-right>
          <BaseButton @click="hidePopup('selectLocation')" size="sm" variant="outline">Thoát</BaseButton>
        </template>
      </LayoutPopup>
    </header>
    <div v-else class="input-search input-search-head w-100">
      <div class="topHeadSearch">
        <i class="head-icon-search fa fa-search"></i>
        <input class="inputSearchHead" placeholder="Nhập tên Sản phẩm, mã SKU,..." v-model="textSearchHead" @keyup="onKeyUpSearchItem" @click="showDataSearchHead = true" />
        <i class="head-icon-remove bx bx-x" v-if="textSearchHead != ''" @click="textSearchHead = ''"></i>
      </div>
      <div class="openPopOverHeadSearch" v-if="showDataSearchHead" @click="showDataSearchHead = false"></div>
      <div class="bottomHeadSearch" v-if="showDataSearchHead">
        <div class="addItemFastHead" @click="clickShowPopAddItem">
          <div class="clickItemFastHead">
            <span class="iconAdd"><i class="el-icon-plus"></i></span>
            <b>Thêm mới sản phẩm</b>
          </div>
        </div>
        <div class="boxShowHeadSearchItem" v-if="listVariationsNew.length > 0">
          <div
            class="item-variations-content-head"
            v-for="(item, index) in listVariationsNew"
            :key="index"
            @click="chooseVariationItem(item, item.idItem, item.useImeiAndSerial, item.useProductBatch)"
          >
            <div class="v-image">
              <img :src="item.images[0] || defaultImg" />
            </div>
            <div class="v-content d-flex">
              <div class="v-info">
                <div class="v-name">{{ item.name }}</div>
                <div class="v-sku">{{ item.upc }}</div>
              </div>
              <div class="v-value">
                <div class="v-price">{{ formatMoney(item.price) }}</div>
                <div v-if="datas.enableInventory">
                  <div class="v-quantity" v-if="item.stockQuantity > 0">SL: {{ item.stockQuantity }} {{ item.unit ? item.unit : "" }}</div>
                  <div class="v-quantity text-danger-on" v-else>Hết hàng</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal -->
    <b-modal hide-footer centered no-close-on-backdrop id="modal-add-item">
      <template #modal-header>
        <b class="fz-18 mb-0">Thêm mới sản phẩm</b>
        <span class="close fz-22 cursor-pointer" @click="clickHidePopAddItem"><i class="fz-22 bx bx-x"></i></span>
      </template>
      <validation-observer ref="observerItem" v-slot="{ validate }">
        <b-form @submit.stop.prevent="clickAddItemOk(validate)">
          <b-form-group class="px-0">
            <validation-provider name="Tên sản phẩm" rules="required|lBetween:3,255|CHECK_HTML" v-slot="{ errors, valid }">
              <label for="itemName">Tên sản phẩm <span class="color-red">*</span></label>
              <b-form-input
                id="itemName"
                class="text-left"
                placeholder="Nhập tên sản phẩm"
                v-model="paramAddItem.name"
                :state="errors[0] ? false : valid ? true : null"
                @keydown.enter.prevent
              />
              <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
            </validation-provider>
          </b-form-group>

          <b-form-group class="px-0">
            <label>Giá bán</label>
            <div>
              <number
                v-model.number="paramAddItem.exportPrice"
                v-bind="numFormat"
                @keydown.native="enterKeyMinus($event)"
                @change="handleInputExportPrice"
                class="text-left form-control"
                placeholder="Nhập giá bán"
              />
            </div>
          </b-form-group>

          <b-form-group class="px-0">
            <b-form-checkbox v-model="paramAddItem.addItem">Thêm sản phẩm vào danh sách sản phẩm</b-form-checkbox>
          </b-form-group>
          <b-form-group class="px-0">
            <div class="row">
              <div class="col-6">
                <label>Barcode/UPC</label>
                <BaseInput class="upc-input"                 
                  :rules="'SKU|lBetween:1,16'"
                  placeholder="Nhập Barcode/UPC" v-model="paramAddItem.upc.code" type="SKU_UPC" :btn="true" @blur="checkUPC(paramAddItem.upc.code, 0)">
                        <template #btn-input v-if="paramAddItem.upc.code == ''">
                      <span class="text-primary" @click="generateBarcode">Tạo</span>
                  </template>
                </BaseInput>
                <span class="text-danger-on" v-if="paramAddItem.upc.valid !== ''">{{ paramAddItem.upc.valid }}</span>
              </div>
              <div class="col-6">
                <label>Đơn vị tính</label>
                <BaseSelect
                  :options="dataUnit"
                  :label="'unitName'"
                  placeholder="Chọn đơn vị tính"
                  v-model="paramAddItem.unit.name"
                  @select="getValueUnit($event)"
                  :showADD="false"
                />
              </div>
            </div>
          </b-form-group>
          <b-form-group class="px-0" v-if="datas.enableInventory">
            <div class="row">
              <div class="col-6">
                <label>Tồn kho ban đầu</label>
                <div>
                  <number v-model.number="paramAddItem.store" v-bind="numFormat" class="text-left form-control" placeholder="0" />
                </div>
              </div>
              <div class="col-6">
                <label>Giá nhập</label>
                <div>
                  <number v-model.number="paramAddItem.importPrice" v-bind="numFormat" class="text-left form-control" placeholder="0" />
                </div>
              </div>
            </div>
          </b-form-group>

          <div class="d-flex justify-content-end mt-3">
            <span class="text-primary mt-2 mr-2 cursor-pointer" @click="clickHidePopAddItem">
              Thoát
            </span>
            <button type="submit" class="btn btn-primary">Hoàn tất</button>
          </div>
        </b-form>
      </validation-observer>
    </b-modal>
    <!--Điều hướng bật cấu hình bán âm-->
    <b-modal v-if="modalActiveNegativeInv" v-model="modalActiveNegativeInv" size="md" centered hide-header hide-footer no-close-on-backdrop id="modalActiveNegativeInv">
      <div class="head-popup-payment-method mb-0">
        <button type="button" aria-label="Close" class="close close-ext font-weight-light" @click="modalActiveNegativeInv = false">×</button>
        <div class="text-title-modal text-bold fz-18">Sản phẩm đã hết hàng</div>
      </div>
      <div class="content-popup-dilivery-method">
        <div class="text-center">
          <img src="@/assets/images/box-decline.svg" />
        </div>
        <div class="mt-2 boxNoteNegativeInv">
          Sản phẩm bạn vừa chọn đã hết hàng. Để được bán âm sản phẩm, vui lòng đi đến <a href="javascript:void(0)" @click="configActiveNegativeInv">Cấu hình bán hàng</a>
        </div>
        <div class="mt-4 text-right bd-line-top-button">
          <el-button class="btn-default btn-default-ext" @click="modalActiveNegativeInv = false">Đóng</el-button>
          <el-button type="primary" @click="configActiveNegativeInv">Đi đến cấu hình</el-button>
        </div>
      </div>
    </b-modal>

    <!--Thông báo tạo đơn hàng thành công-->
    <b-modal v-if="modalRemovePos" v-model="modalRemovePos" size="md" centered hide-header hide-footer no-close-on-backdrop id="modalActiveNegativeInv">
      <div class="head-popup-payment-method mb-0">
        <button type="button" aria-label="Close" class="close close-ext font-weight-light" @click="modalRemovePos = false">×</button>
        <div class="text-title-modal text-bold fz-18">Xóa đơn hàng</div>
      </div>
      <div class="content-popup-dilivery-method">
        <div class="text-center">
          <img src="@/assets/images/danger.png" />
        </div>
        <div class="mt-4 boxNoteNegativeInv">
          Mọi thông tin đơn sẽ không được lưu lại nếu bạn xóa. Bạn chắc chứ?
        </div>
        <div class="mt-4 text-right bd-line-top-button">
          <el-button class="btn-default btn-info-ext" @click="btnSavePos(), (modalRemovePos = false)">Lưu đơn nháp</el-button>
          <el-button type="primary" @click="btnRemovePos(), (modalRemovePos = false)">Đồng ý</el-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import { defaultImg, showMess, popupAllowedMinus, getNewDefaultPos, getParamAddItem } from "../utils/pos";
import { AuthService } from "@/services/auth.service";
import { getLocationName, getcurrentMerchantName, setStorageItem, getStorageItem, removeStorageItem, setCookies, storeCommit, getStorageItemNotParse } from "@/utils/auth";
import { RoleService } from "@/services/nextshop/role.service";
import getListLocation from "@/mixins/location/getListLocation";
import { OrdersService } from "@/services/nextshop/orders.service";
import { ProductService } from "@/services/nextshop/product.service";
import caculateMoneyPos from "../mixins/pos";
import increasePos from "../mixins/pos";
import caculateMoneyPosItem from "../mixins/pos";
import dissociationThousand from "../mixins/pos";
import addVariForListCart from "../mixins/pos";
import multiplicationThousand from "../mixins/pos";
import returnStockQuantityVari from "../mixins/pos";
import getListUnit from "@/mixins/items/getListUnit";
import genBarcode from "@/mixins/items/handleBarcode";
import { numFormat } from "../utils/pos";
import enterKeyMinus from "../mixins/pos";
import moment from "moment";
import { ItemService } from "@/services/nextshop/item.service";
import handlerReqCreatItem from "@/mixins/orders/reqAddItem";
import _ from "lodash";

export default {
  name: "Head",
  props: {
    datas: {
      type: Object,
      default: () => {
        return {};
      },
    },
    notShowHead: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [
    getListLocation,
    caculateMoneyPos,
    increasePos,
    caculateMoneyPosItem,
    dissociationThousand,
    addVariForListCart,
    returnStockQuantityVari,
    getListUnit,
    genBarcode,
    enterKeyMinus,
    multiplicationThousand,
    handlerReqCreatItem,
  ],
  data() {
    return {
      locationNameSelected: getLocationName(),
      listLocation: [],
      userLogin: getcurrentMerchantName(),
      defaultImg: defaultImg,
      listVariationsNew: [],
      textSearchHead: "",
      popDeleteItemPos: false,
      showDataSearchHead: false,
      dataUnit: [],
      paramAddItem: getParamAddItem(),
      numFormat: numFormat,
      upcItem: "",
      modalActiveNegativeInv: false,
      modalRemovePos: false,
      item_rm_id: -1,
    };
  },
  async created() {
    this.checkLocation();
    this.getListProduct(5);
    this.onKeyPressSearchBarcode();
  },

  computed: {
    ...mapGetters("sell", ["getRmId"]),
    itemPos: {
      get() {
        let index = this.datas.orders.length > 0 ? this.datas.orders.findIndex((item) => item.rm_id == this.getRmId) : -1;
        if (index == -1) {
          index = 0;
          this.SET_RM_ID(index);
        }
        return this.datas.orders[index];
      },
      set(newValue) {
        let index = this.datas.orders.length > 0 ? this.datas.orders.findIndex((item) => item.rm_id == this.getRmId) : -1;
        if (index == -1) {
          index = 0;
          this.SET_RM_ID(index);
        }
        this.datas.orders[index] = newValue;
      },
    },
  },

  methods: {
    ...mapMutations("sell", ["SET_ADD_SELL", "SET_RM_ID", "SET_REMOVE_SELL", "SET_SAVE_SELL", "SET_LOADING"]),
    //Location
    async selectLocation() {
      this.listLocation = await this.getListLocation();
      if (this.listLocation) {
        this.showPopup("chon-chi-nhanh");
      }
    },
    async setLocation(data) {
      try {
        this.locationNameSelected = data.name;
        storeCommit("auth/SET_CURRENT_LOCATION", data.coLocationId);
        setCookies("LID", data.coLocationId);
        setCookies("IID", data.inventories && data.inventories.length > 0 ? data.inventories[0].coInventoryId : "");
        setStorageItem("locationName", JSON.stringify(data));
        setStorageItem("inventoryID", data.inventories && data.inventories.length > 0 ? data.inventories[0].coInventoryId : "");
        await RoleService.getListPermissionsUser();
        this.hidePopup("chon-chi-nhanh");
        location.reload();
      } catch (error) {
        console.log(error);
      }
    },
    checkLocation() {
      if (!getStorageItem("locationName")) {
        this.showPopup("chon-chi-nhanh");
      } else {
        this.locationNameSelected = getLocationName();
      }
    },
    dashboard() {
      this.$router.push("/dashboard");
    },
    logout() {
      AuthService.makeLogout();
      removeStorageItem("locationName");
    },
    fullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement) {
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    addNewPos() {
      const resultCheck = this.datas.orders.findIndex((e) => e.listItemCart && e.listItemCart.length == 0);
      if (this.datas.orders.length > 6) {
        showMess(this, "Thông báo", "Số lượng đơn hàng lưu trữ đạt giới hạn, vui lòng thanh toán đơn cũ!", "danger", "b-toaster-top-right", 1000);
        return false;
      } else {
        if (resultCheck !== -1) {
          showMess(this, "Thông báo", "Đơn hàng " + (resultCheck + 1) + " chưa có sản phẩm, không thể tạo đơn hàng mới!", "danger", "b-toaster-top-right", 1000);
          return false;
        } else {
          const itemId = this.getNumberUnique();
          this.SET_ADD_SELL({ ...getNewDefaultPos(), id: itemId, rm_id: itemId });
          this.SET_RM_ID(itemId);
        }
      }
    },
    transferPos(rm_id) {
      this.SET_RM_ID(rm_id);
    },
    deletePos(rm_id) {
      if (this.datas.orders.length > 0) {
        const index = this.datas.orders.length > 0 ? this.datas.orders.findIndex((item) => item.rm_id == rm_id) : -1;
        const lengthCart = this.datas.orders[index].listItemCart ? this.datas.orders[index].listItemCart.length : 0;
        this.item_rm_id = index;
        if (lengthCart == 0) {
          if (this.datas.orders.length == 1) {
            showMess(this, "Thông báo", "Đơn hàng là mặc định, không thể xoá!", "danger", "b-toaster-top-right", 1000);
            return false;
          } else {
            let item_id = 0;
            if (index == 0) {
              item_id = this.datas.orders[index + 1] != undefined ? this.datas.orders[index + 1].rm_id : 0;
            } else {
              item_id = this.datas.orders[index - 1] != undefined ? this.datas.orders[index - 1].rm_id : 0;
            }
            this.SET_RM_ID(item_id);
            this.SET_REMOVE_SELL(index);
            showMess(this, "Thông báo", "Xoá đơn hàng thành công", "success", "b-toaster-top-right", 1000);
          }
        } else {
          this.modalRemovePos = true;
          return false;
        }
      } else {
        this.SET_ADD_SELL({ ...getNewDefaultPos() }), this.SET_RM_ID(0);
        location.reload();
      }
    },
    btnRemovePos() {
      //api: Remove item
      const index = this.item_rm_id;
      const _id = this.datas.orders[index] != undefined ? this.datas.orders[index].id : 0;
      if (String(_id).length > 6) {
        this.deleteCallApi(_id);
      }
      //api: Remove item

      if (this.datas.orders.length == 1) {
        this.SET_REMOVE_SELL(index);
        this.SET_ADD_SELL({ ...getNewDefaultPos() });
        this.SET_RM_ID(0);
        location.reload();
      } else {
        let item_id = 0;
        if (index == 0) {
          item_id = this.datas.orders[index + 1] != undefined ? this.datas.orders[index + 1].rm_id : 0;
        } else {
          item_id = this.datas.orders[index - 1] != undefined ? this.datas.orders[index - 1].rm_id : 0;
        }
        this.SET_RM_ID(item_id);
        this.SET_REMOVE_SELL(index);
        showMess(this, "Thông báo", "Xoá đơn hàng thành công", "success", "b-toaster-top-right", 1000);
      }
    },
    btnSavePos() {
      this.SET_SAVE_SELL(true);
    },
    async deleteCallApi(id) {
      try {
        const params = {
          id: id,
          reason: "Hủy đơn hàng",
        };
        await OrdersService.cancelItem(params);
      } catch (error) {
        console.log(error);
      }
    },
    onKeyUpSearchItem: _.debounce(function() {
      this.getListProduct(20);
    }, 500),
    async getListProduct(limit) {
      try {
        let param = {
          queryString:
            "[{name}]==='''" + this.textSearchHead + "''' or {variations.sku}like'''" + this.textSearchHead + "''' or {variations.upc}like'''" + this.textSearchHead + "'''",
          pagingAndSorting: {
            limit: limit,
            lastIndex: "",
            sortOrder: "DESC",
          },
        };
        if (this.textSearchHead == "") {
          param.queryString = "";
        }
        this.listVariationsNew = [];
        const response = await ProductService.getList(param);
        if (response.status === 200) {
          const dataRes = response.data;
          dataRes.map(async (e) => {
            const arrVariations = e.variations;
            arrVariations.map((variation) => {
              variation = this.returnStockQuantityVari(variation);
              if (variation.prices.length > 0) {
                variation.prices[0].amount = this.dissociationThousand(variation.prices[0].amount);
                if (variation.prices[1]) {
                  variation.prices[1].amount = this.dissociationThousand(variation.prices[1].amount);
                }
              }
              variation.unit = e.unit.name;

              let exportPrice = 0;
              if (variation.prices.length > 0) {
                variation.prices.map((vl, idx) => {
                  if (vl.priceTypeCode === "PRICE_EXPORT") {
                    exportPrice = variation.prices[idx].amount;
                  }
                });
              }

              const checkImagesVari = variation.images.filter((e) => e != "");
              const checkImagesItem = e.images.filter((v) => v != "");
              variation.images = checkImagesVari;
              if (checkImagesVari.length == 0 && checkImagesItem.length > 0) {
                variation.images = e.images;
              }

              this.listVariationsNew.push({
                ...variation,
                idItem: e.itemId,
                price: exportPrice,
                useImeiAndSerial: e.metaSearchable.useImeiAndSerial == "true" ? true : false,
                useProductBatch: e.metaSearchable.useProductBatch == "true" ? true : false,
                unit: e.unit.name,
              });
            });
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    async chooseVariationItem(variation, idItem, useImeiAndSerial, useProductBatch) {
      this.SET_LOADING(true);

      const index =
        this.itemPos.listItemCart.length > 0
          ? this.itemPos.listItemCart.findIndex(
              (e) =>
                e.itemInstance &&
                (e.itemInstance.itemVariationId === variation.variationId || e.itemInstance.itemVariationId === variation._itemVariationId) &&
                e.lineItemId === idItem
            )
          : -1;
      const result = await this.addVariForListCart(variation, idItem, useImeiAndSerial, useProductBatch);

      this.SET_LOADING(false);

      if (this.itemPos.listItemCart.length === 0 || index === -1) {
        if (variation.stockQuantity == 0) {
          if (!useImeiAndSerial && !useProductBatch) {
            if (this.datas.enableInventory !== false) {
              if (this.datas.activeNegativeInv) {
                const resPopup = popupAllowedMinus();
                resPopup.then((_result) => {
                  if (_result.value) {
                    this.itemPos.listItemCart.push(result);
                    this.caculateMoneyPos(this.itemPos);
                    showMess(this, "Thông báo", "Thêm sản phẩm vào đơn thành công!", "success", "b-toaster-top-right", 1000);
                    return false;
                  }
                });
              } else {
                this.modalActiveNegativeInv = true;
                return false;
              }
            } else {
              this.itemPos.listItemCart.push(result);
              this.caculateMoneyPos(this.itemPos);
              showMess(this, "Thông báo", "Thêm sản phẩm vào đơn thành công!", "success", "b-toaster-top-right", 1000);
              return false;
            }
          } else {
            if (useImeiAndSerial) {
              showMess(this, "Thông báo", "Sản phẩm không được bán vượt quá số tồn kho.Vui lòng nhập kho EMEI/se-ri cho sản phẩm này.", "danger", "b-toaster-top-right", 1000);
              return false;
            }
            if (useProductBatch) {
              showMess(this, "Thông báo", "Sản phẩm không được bán vượt quá số tồn kho. Vui lòng nhập kho Lô cho sản phẩm này.", "danger", "b-toaster-top-right", 1000);
              return false;
            }
            return false;
          }
        } else {
          this.itemPos.listItemCart.push(result);
          this.caculateMoneyPos(this.itemPos);
          showMess(this, "Thông báo", "Thêm sản phẩm vào đơn thành công!", "success", "b-toaster-top-right", 1000);
          return false;
        }
      } else {
        if (index != -1) {
          this.itemPos = this.increasePos(this.itemPos, index);
          if (this.itemPos.listItemCart[index]) {
            this.caculateMoneyPosItem(this.itemPos.listItemCart[index]);
          }
          this.caculateMoneyPos(this.itemPos);
          return false;
        }
      }
      return true;
    },
    async clickShowPopAddItem() {
      this.dataUnit = await this.getListUnit();
      this.$bvModal.show("modal-add-item");
    },
    clickHidePopAddItem() {
      this.$bvModal.hide("modal-add-item");
    },
    getValueUnit(data) {
      if (data !== null) {
        if (data.unitName != "") {
          this.paramAddItem.unit.name = data.unitName;
        }
      }
    },
    handleInputExportPrice() {
      if (this.paramAddItem.exportPrice == "") {
        this.paramAddItem.exportPricet = 0;
      }
    },
    async generateBarcode() {
      try {
        const resBarcode = await this.genBarcode(1);
        this.paramAddItem.upc.code = resBarcode;
      } catch (error) {
        console.log(error);
      }
    },
    async getItemCode() {
      let check = 0;
      if (this.upcItem !== "") {
        try {
          const params = {
            queryString: "{variations.upc} == '''" + this.upcItem + "'''",
            pagingAndSorting: { sortOrder: "DESC", limit: 1 },
          };
          const response = await ProductService.getList(params);
          if (response.success) {
            check = response.data.length;
          }
        } catch (error) {
          console.log(error);
        }
      }
      return check;
    },
    async clickAddItemOk(validate) {
      validate().then(async () => {
        const el = document.querySelector(".is-invalid");
        if (el) {
          el.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          el.focus();
          return;
        } else {
          let params = {
            name: this.paramAddItem.name,
            metaSearchable: {
              brand: "",
              madeBy: "",
              isSelling: true,
              category: "",
            },
            priceItem: {
              exportPrice: this.paramAddItem.exportPrice,
              importPrice: this.paramAddItem.importPrice,
            },
            unit: {
              name: this.paramAddItem.unit.name,
            },
            weightInGram: 0,
            upc: this.paramAddItem.upc.code,
            sku: "",
          };
          this.SET_LOADING(true);
          let check = true;
          let result = {};
          if (this.paramAddItem.addItem) {
            //Add cart:  Save DB
            const checkItemAddd = await this.getItemCode();
            if (checkItemAddd === 0) {
              const response = await ProductService.createItem(this.handlerReqCreatItem(params, []));
              if (response.success) {
                if (this.datas.enableInventory && this.paramAddItem.store > 0) {
                  const dataInventory = {
                    currency: "VND",
                    locationId: response.data.item.locationToCreate,
                    inventoryIds: [getStorageItemNotParse("inventoryID")],
                    lineItemReqs: [
                      {
                        lineItemId: response.data.item.id,
                        itemInstance: {
                          moreInformation: {
                            sku: response.data.item.variations && response.data.item.variations.length > 0 ? response.data.item.variations[0].sku : "",
                            upc: response.data.item.variations && response.data.item.variations.length > 0 ? response.data.item.variations[0].upc : "",
                            name: this.paramAddItem.name,
                            options: response.data.item.options,
                            heightInCentimeter: 0,
                            lengthInCentimeter: 0,
                            version: 0,
                            weightInGram: 0,
                            widthInCentimeter: 0,
                          },
                        },
                        unit: response.data.item.unit.name,
                        quantity: this.paramAddItem.store,
                        lineItemOtherInfo: [
                          {
                            quantity: this.paramAddItem.store,
                            unitPrice: this.multiplicationThousand(this.paramAddItem.exportPrice),
                            inventoryId: getStorageItemNotParse("inventoryID"),
                          },
                        ],
                        totalAmount: this.paramAddItem.store * this.multiplicationThousand(this.paramAddItem.exportPrice),
                        amount: this.paramAddItem.store * this.multiplicationThousand(this.paramAddItem.exportPrice),
                        unitPrice: this.multiplicationThousand(this.paramAddItem.exportPrice),
                        note: "",
                        expiredAt: new Date(moment().add(100, "years")).toISOString(),
                        checkInAt: new Date(Date.now()).toISOString(),
                      },
                    ],
                  };
                  await ItemService.checkInInventory(dataInventory);
                }
                const variation = {
                  ...response.data.item.variations[0],
                  unit: this.paramAddItem.unit.name,
                  prices: [
                    {
                      amount: this.paramAddItem.exportPrice != "" ? this.paramAddItem.exportPrice : 0,
                      priceTypeCode: "PRICE_EXPORT",
                    },
                  ],
                };
                check = true;
                result = await this.addVariForListCart(variation, response.data.item.id, false, false);
              }
            }
          } else {
            //Add cart:  Not save DB
            const idItem = this.getNumberUnique();
            const variation = {
              itemVariationId: idItem,
              name: this.paramAddItem.name,
              sku: this.paramAddItem.sku,
              upc: this.paramAddItem.upc.code,
              ordinal: 0,
              weightInGram: 0,
              lengthInCentimeter: 0,
              widthInCentimeter: 0,
              heightInCentimeter: 0,
              options: [],
              images: [],
              unit: this.paramAddItem.unit.name,
              prices: [
                {
                  amount: this.paramAddItem.exportPrice != "" ? this.paramAddItem.exportPrice : 0,
                  priceTypeCode: "PRICE_EXPORT",
                },
              ],
            };
            check = true;
            result = await this.addVariForListCart(variation, idItem, false, false);
          }
          if (check) {
            this.itemPos.listItemCart.push(result);
            this.caculateMoneyPos(this.itemPos);
            showMess(this, "Thông báo", "Thêm mới sản phẩm thành công", "success", "b-toaster-top-right", 1000);
            this.SET_LOADING(false);
          }
          this.$bvModal.hide("modal-add-item");
          this.paramAddItem = getParamAddItem();
        }
      });
    },
    configActiveNegativeInv() {
      this.$router.push("/setting/config");
    },
    async checkUPC(value, index) {
      const result = await this.checkDublicate("upc", value)
      if (index === undefined && result) {
        this.paramAddItem.upc.valid = "Mã UPC đã tồn tại"
      } else if (index != undefined && result) {
        this.paramAddItem.upc.valid = "Mã UPC đã tồn tại"
      } else if (index === undefined && !result) {
        this.paramAddItem.upc.valid = ""
      } else if (index != undefined && !result) {
        this.paramAddItem.upc.valid = ""
      }
    },
    async checkDublicate(type, value) {
      try {
        const params = {
          pagingAndSorting: { limit: 10, lastIndex: "", sortOrder: "DESC" },
          queryString: "{variations." + `${type}` + "}=='''" + `${value}` + "'''"
        }

        const response = value != "" ? await ProductService.getList(params) : { data: [] }

        if (response.data.length > 0) {
          return true
        } else {
          return false
        }
      } catch (error) {
        console.log(error)
      }
    },
    async onKeyPressSearchBarcode() {
      let keys = []
      document.onkeypress = async (e) => {
				const key = e.key
				if(key === 'Enter' && keys.length > 0) {
            await this.showPressSearchBarcode(keys.join(''))
            return false
				}
				keys.push(key)
				setTimeout(() => {keys.length = 0}, 300)
			};
    },

    async showPressSearchBarcode (key) {
      console.log('Key:' + key)
      this.textSearchHead = key
      await this.getListProduct(2);
      if(this.listVariationsNew.length == 1 && this.listVariationsNew[0].upc === key){
        const item = this.listVariationsNew[0]
        this.chooseVariationItem(item, item.idItem, item.useImeiAndSerial, item.useProductBatch)
      }
    }
  },
};
</script>
<style>
.pos-item li {
  padding: 18px 24px 18px 15px;
}
.pos-item .pos-item-delete {
  width: 20px;
  height: 20px;
  right: 3px;
  display: inline-block;
  font-size: 15px !important;
}
.pos-item .pos-item-name {
  display: inline-block;
  padding: 15px;
}
.openPopOverHeadSearch {
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 1;
  top: 0;
  left: 0;
  background: transparent;
}
.bottomHeadSearch {
  display: block;
}

</style>

<style scoped>

</style>
